import script from "./CompanyHireContactPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyHireContactPanel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__